// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"24e6b461","513":"64bb4dd1","703":"1f8be327"}[chunkId] + ".chunk.js";
};